import { CapsuleSingleSelectDropdown } from "@screencloud/screencloud-ui-components";
import { ALL_OPTION, AuditLogFilterProps } from "./const";
import { useAllActiveUsersWithNoLimitQuery, UsersOrderBy } from "src/types.g";
import { useMemo } from "react";

interface PersonFilterProps extends AuditLogFilterProps {
  isPersonDropdownOpen: boolean;
  handlePersonDropdownOpen: () => void;
}

export const PersonFilter = (props: PersonFilterProps): JSX.Element => {
  const { data: allActiveUsersData, loading: allActiveUsersLoading } =
    useAllActiveUsersWithNoLimitQuery({
      fetchPolicy: "cache-first",
      variables: {
        orderBy: [
          UsersOrderBy.GivenNameAsc,
          UsersOrderBy.FamilyNameAsc,
          UsersOrderBy.IdAsc,
        ],
      },
      skip: !props.isPersonDropdownOpen,
    });

  const allUsers = allActiveUsersData?.allUsers?.nodes || [];

  const userOptions = useMemo(
    () => [
      ALL_OPTION,
      ...(allUsers.map((user, index) => ({
        key: `${user.id}-${index}`,
        text:
          `${user.givenName || ""} ${user.familyName || ""}`.trim() ||
          "Unknown User",
        value: user.id,
      })) || []),
    ],
    [allActiveUsersData?.allUsers?.nodes],
  );

  return (
    <CapsuleSingleSelectDropdown
      label="Person"
      optionHeader="Person"
      options={userOptions}
      onChange={props.onChange}
      defaultValue={null}
      onOpen={props.handlePersonDropdownOpen}
      loading={allActiveUsersLoading}
      value={props.value}
      position={props.popoverPosition}
    />
  );
};
